import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MetricsService, Summary } from 'src/app/services/metrics.service';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MarkdownComponent } from 'ngx-markdown';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-shift-summary-dialog',
    templateUrl: './shift-summary-dialog.component.html',
    styleUrls: ['./shift-summary-dialog.component.scss'],
    imports: [MatDialogTitle, MatIcon, CdkScrollable, MatDialogContent, NgIf, MarkdownComponent, MatProgressBar, MatDialogActions, MatButton]
})
export class ShiftSummaryDialog implements OnInit, OnDestroy {

  summary:string="";
  isLoading:boolean=true;
  status:string="";

  // Following messages are displayed to the user so they know something is happening while summary is generated asynchronously
  statusMessages:string[] = [
    'Sending data to Gemini...', 
    'Processing data...', 
    'Analyzing shift metrics...', 
    'Analyzing hourly metrics...', 
    'Analyzing downtime...', 
    'Analyzing faults...', 
    'Analyzing root cause user data...',
    'Summarizing data...',
    'Continuing to analyze shift data...',
    'Continue to process data, taking longer than expected...', 
    'Continuing to process data...', 
    'Taking longer than expected to generate summary... '
  ];
  statusIndex:number=1;
  totalCounter:number = 0;

  summarySub$!: Subscription;
  
  constructor(
    public dialogRef: MatDialogRef<ShiftSummaryDialog>,
    private svcMetrics: MetricsService,
    @Inject(MAT_DIALOG_DATA) public inData: any
  ) { }

  ngOnInit(): void {
    this.status = this.statusMessages[0]; // Show the initial status message
    this.loadSummary(); // Start loading the summary
  }

  ngOnDestroy(): void {
    if (this.summarySub$) this.summarySub$.unsubscribe();
  }

  loadSummary(): void {
    if (this.summarySub$) this.summarySub$.unsubscribe();

    // Request the summary, it will be generated asynchronously
    this.svcMetrics.requestSummary().subscribe(
      out => {
        console.log("OUT", out);

        this.summarySub$ = this.svcMetrics.retrieveSummary(out.Body.SummaryID).subscribe(
          (out) => {
            let status:Summary = out.Body;

            if (status.CurrentStatus == "Complete") {
              // Successfully completed
              this.summary = status.Summary;
              this.isLoading = false;
              this.summarySub$.unsubscribe();
            } else if (status.CurrentStatus == 'Failure') {
              // Something failed, all we can do is show the error.
              this.summary = status.Summary; // Displaying the error from Gemini
              console.error("FAILED TO GENERATE AI SUMMARY", status.Summary);
              this.isLoading = false;
              this.summarySub$.unsubscribe();
            } else {
              // Still waiting, update status message
              console.log("CurrentStatus", status.CurrentStatus);
              this.status = this.statusMessages[this.statusIndex]; // Change the status message

              // Increment the index or set back to 0
              this.statusIndex += 1; // Incremenet the statusIndex
              this.totalCounter += 1; // Keep track of the total number of times
      
              if (this.totalCounter > 48) {
                // We've waited too long, this isn't going to work just abort the attempt
                console.error("FAILED TO LOAD SHIFT SUMMARY!!!");
                this.summarySub$.unsubscribe(); // Stop trying, we're done
                this.status = 'FAILED TO GENERATE SUMMARY, PLEASE CLOSE AND TRY AGAIN...'; // Display our faliure to the user
              } else if ( this.statusIndex >= this.statusMessages.length) {
                // Going to assume something has gone wrong, so force a retry
                this.statusIndex = 1; // Reset the index
                this.status = this.statusMessages[0];
              }
            }
          }
        )
      }
    );
  }

  onNoClick():void {
    this.dialogRef.close();
  }

}
